<div class="ui vertical basic segment wrap" *ngIf="!fullScreenMode">
  <div class="upper-section" appPadding="16px">
    <div
      class="column-header"
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="start center"
      appPadding
      paddingY="16px"
    >
      <h2 class="ui large header">All Conversations</h2>
      <span
        class="badge"
        [ngClass]="{ red: aggregateCount !== 0 }"
        fxLayout="row"
        fxLayoutAlign="center center"
        >{{ aggregateCount || 0 }}</span
      >
    </div>

    <app-advanced-search-filter
      [placeholder]="'Search Chats'"
      (onSearch)="searchRecords($event)"
      [hasFilters]="true"
      [hasDisplayRows]="false"
      [hasSort]="false"
      [headerFilters]="headerFilters"
      [headers]="headers"
      [searchFilters]="searchFilter"
      appMargin
      marginY="16px"
      (advancedSearch)="advancedSearch($event)"
      (cancelAd)="cancelAd()"
    ></app-advanced-search-filter>

    <button
      appMargin
      [marginT]="'16px'"
      class="ui large primary button large2"
      (click)="initiateChat()"
    >
      Start new Chat
    </button>
  </div>
  <div *ngIf="success || error" appMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div
    class="ui vertical basic segment lower-section"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <!-- chat conversations -->
    <div class="data" appPadding paddingB="24px">
      <app-conversation
        *ngFor="let conversation of conversations; let i = index"
        [conversation]="conversation"
        [isSelected]="selectedConversation"
        (click)="loadConversationView(conversation)"
      ></app-conversation>
    </div>
    <div
      class="empty-data-view"
      *ngIf="conversations && conversations.length < 1"
    >
      <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <img src="assets/images/empty-data.svg" alt="" />
        <div class="text">
          <h3 class="heading">
            This is where you’ll manage your Chat with NCC
          </h3>
          <p class="description">
            Click the Start New Chat button above to start chatting
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
